<!-- Native-Angular port of account-v2/.../advocacy/group/contests/contests.html.
     For QA login the property has no contests, so only the Current sub-tab's
     empty-state placeholder renders. Upcoming/Past content (which uses the
     still-AngularJS <ft-contests-list>) is gated behind the section's
     *ngIf and doesn't render until the section is active — same as the
     AngularJS baseline. Audiences (M-leaf-3) will port <ft-contests-list>
     to native and contests will pick it up automatically by selector. -->
<ft-initialized-content [isInitialized]="isInitialized">
    <ft-sections #ftSecs [registry]="sectionsRegistry">
        <section class="ft-master-section ft-contests-master">
            <section class="ft-section ft-contests-list-section">
                <div class="ft-container">

                    <div class="ft-nav ft-navbar ft-contexttabs-nav">
                        <ul>
                            <li [ngClass]="{'active': ftSecs.isSectionActive('current')}">
                                <a ftSectionTrigger="current">Current Campaigns</a>
                            </li>
                            <li [ngClass]="{'active': ftSecs.isSectionActive('upcoming')}">
                                <a ftSectionTrigger="upcoming">Upcoming</a>
                            </li>
                            <li [ngClass]="{'active': ftSecs.isSectionActive('past')}">
                                <a ftSectionTrigger="past">Past</a>
                            </li>
                            <li class="ft-navitem-action" *ngIf="photoAdvocacy?.touchpoints?.item?.[0]?.isActive == 1 && canEditData">
                                <a (click)="createNewContest()">
                                    <i class="ft-icn-plus"></i> {{'flipto.account.sections.platform.photoAdvocacy.NewContest' | translate}}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ft-section name="current">
                        <div class="ft-contexttab-view active">
                            <div class="placeholder-panel" [hidden]="photoAdvocacy?.contests?.item?.length">
                                {{'flipto.account.platform.ThereAreNoContestAddANew' | translate}}
                            </div>

                            <!-- Contest ended -->
                            <ng-container *ngFor="let contest of (photoAdvocacy?.contests?.item ?? [])">
                                <div class="ft-panel contest-panel current contest-active"
                                     *ngIf="contest.ended"
                                     (click)="showContest(contest, 'winners')">
                                    <div class="panel-image" [style.background-image]="'url(' + getContestBackgroundImage(contest) + ')'">
                                        <div class="panel-matte"></div>
                                    </div>
                                    <div class="contest-display ft-v-align-container">
                                        <div class="contest-display-content ft-v-align-content">
                                            <div class="contest-theme-label" *ngIf="contest.theme != 0">{{'flipto.account.platform.photoAdvocacy.ThemedContest' | translate}}</div>
                                            <div class="contest-title">{{contest.name}}</div>
                                            <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                            <div class="contest-status"
                                                 [ngClass]="{'is-off': !(contest.isActive | parse:'bool')}">
                                                <ft-contest-status [contest]="contest" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="contest-stats ft-v-align-container">
                                        <div class="contest-stats-content ft-v-align-content">
                                            <p><ft-stat [value]="(contest.totalFinalists || 0) | number" [label]="'flipto.account.Storytellers' | translate | lowercase" /></p>
                                            <p><ft-stat [value]="(contest.totalShares || 0) | number" [label]="'flipto.account.TotalShares' | translate | lowercase" /></p>
                                            <p><ft-stat [value]="(contest.totalFollowers || 0) | number" [label]="'flipto.account.FriendsReached' | translate | lowercase" /></p>
                                            <p><ft-stat [value]="(contest.totalSignups || 0) | number" [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" /></p>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Contest in progress -->
                            <ng-container *ngFor="let contest of (photoAdvocacy?.contests?.item ?? [])">
                                <div class="ft-panel contest-panel current contest-active"
                                     *ngIf="contest.inProgress"
                                     (click)="showContest(contest, 'submissions')">
                                    <div class="panel-image" [style.background-image]="'url(' + getContestBackgroundImage(contest) + ')'">
                                        <div class="panel-matte"></div>
                                    </div>
                                    <div class="contest-display ft-v-align-container">
                                        <div class="contest-display-content ft-v-align-content">
                                            <div class="contest-theme-label" *ngIf="contest.theme != 0">{{'flipto.account.platform.photoAdvocacy.ThemedContest' | translate}}</div>
                                            <div class="contest-title" [innerHTML]="contest.name"></div>
                                            <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
                                            <div class="contest-status" *ngIf="!(contest.isActive | parse:'bool')"
                                                 [ngClass]="{'is-off': !(contest.isActive | parse:'bool')}">
                                                <ft-contest-status [contest]="contest" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="contest-stats ft-v-align-container">
                                        <div class="contest-stats-content ft-v-align-content">
                                            <p><ft-stat [value]="(contest.totalFinalists || 0) | number" [label]="'flipto.account.Storytellers' | translate | lowercase" /></p>
                                            <p><ft-stat [value]="(contest.totalShares || 0) | number" [label]="'flipto.account.TotalShares' | translate | lowercase" /></p>
                                            <p><ft-stat [value]="(contest.totalFollowers || 0) | number" [label]="'flipto.account.FriendsReached' | translate | lowercase" /></p>
                                            <p><ft-stat [value]="(contest.totalSignups || 0) | number" [label]="'flipto.account.WarmLeadsEarned' | translate | lowercase" /></p>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ft-section>

                    <ft-section name="upcoming">
                        <div class="ft-contexttab-view active">
                            <ft-contests-list select="upcoming" />
                        </div>
                    </ft-section>

                    <ft-section name="past">
                        <div class="ft-contexttab-view active">
                            <ft-contests-list select="past" />
                        </div>
                    </ft-section>

                </div>
            </section>
        </section>
    </ft-sections>
</ft-initialized-content>
<!-- WS5 router-severance (bottom-up, innermost): hosts the native
     advocacy.contests.{submissions,winners,details,invitations} (FtContestContainerComponent)
     + advocacy.contests.advocate (DetailsComponent) — all native — so a plain
     @uirouter/angular <ui-view> hosts them. MUST be native before/with the ancestor
     (AdvocacyGroupComponent) outlet: a native <ui-view> ancestor over an AngularJS
     <ft-ui-view-wrapper> descendant double-renders (the #83 Advocacy-Contests css
     symptom was exactly that — converting the outer first while this stayed AngularJS).
     Same DetailsComponent-under-native-<ui-view> pattern as stories-curation-shell. -->
<ui-view />
